import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryFiscalRegimeNotSupported extends AnnualSummaryError {
    fiscalRegime;
    constructor(fiscalRegime, options) {
        super('Fiscal regime code is not supported', options);
        this.fiscalRegime = fiscalRegime;
    }
}
export default AnnualSummaryFiscalRegimeNotSupported;
